import React, { useState, useEffect, useMemo, useLayoutEffect } from "react"
import closeIcon from "@/public/icons/close-dark-new.svg"
import filterAll from "@/public/icons/filter-all.svg"
import checkIcon from "@/public/icons/check-icon-new.svg"
import MissingImage from "@/public/images/image-missing.png"
import DesignImage from "@/public/images/design-missing.png"
import { cleanRedirectLinks, getAsPDPThumbnail, sanitizeInnerHtml } from "@/utils/helper"

const ProductColorFinish = ({
  swatchUrl,
  isDiscontinued,
  isColorDiscontinued,
  isShape,
  image,
  showModal,
  isColor,
  closeModal,
  colorsPopUp,
  openFilter,
  showActivePreview,
  updateShapeImagePreview,
  modalColorApplyBtn,
  applyBtn,
  i18n,
  showFilter,
  colorFamily,
  colorFamilyCount,
  accountName = "",
  presetConfig = {},
  productImages=[],
  applySelectedShape,
  styleOptionsNotPresent,
  selectYourStyleInfo,
  ...props
}) => {
  const [colorFinishMapping, setColorFinishMapping] = useState([])
  const [colorFamilyDetails, setcolorFamilyDetails] = useState([])
  const [selectedColors, setSelectedColors] = useState([])
  const [activeSku, setActiveSku] = useState(null)
  const [activeSkuImg, setactiveSkuImg] = useState(null)
  const [hoveredSku, setHoveredSku] = useState(null)
  const [hoverSkuImg, setHoverSkuImg] = useState(null)
  const [showNoDesignNote, setShowNoDesignNote] = useState(false)
  useEffect(() => {
    setcolorFamilyDetails(colorFamily)
    if (colorFamily && colorFamily.length > 0) {
      const activeColor = colorFamily?.find(
        cf => cf.split("|")[3] === props?.activeSku
      )
      let activeSku_s =activeColor ? activeColor.split("|")[3] : colorFamily[0].split("|")[3];
      setActiveSku(activeSku)
      if(activeColor){
        let imageTag = productImages.filter((image) => image.sku === activeSku_s);
        setactiveSkuImg(imageTag.length > 0  ? imageTag[0].tag: null)
      }
    }
    setColorFinishMapping(colorFamilyCount)
  }, [colorFamily, colorFamilyCount])

  useLayoutEffect(() => {
    openFilter()
  }, []);

  const ColorFinishLength =
    colorFinishMapping &&
    colorFinishMapping.reduce((total, color) => {
      const count = parseInt(color.split("|")[1])
      return total + count
    }, 0)

  const handleCheckboxChange = (event, colorItem) => {
    const checkboxValue = event.target.value
    const isChecked = event.target.checked
    if (isChecked) {
      setSelectedColors(prevColors => [...prevColors, colorItem])
    } else {
      setSelectedColors(prevColors =>
        prevColors.filter(selectedColor => selectedColor !== colorItem)
      )
    }
  }

  const colorFamilyFilteredValues = colorFamilyDetails
    ? colorFamilyDetails.filter(value => {
        return selectedColors.includes(value.split("|")[0])
      })
    : []
  
  const timeout = (delay) => new Promise(res => setTimeout(res, delay)); 
  const showActivePreviewImg = async (skuValue, imageValue) => {
    setActiveSku(skuValue)
    setactiveSkuImg(imageValue)
    await timeout(2000);
    if(isShape){
      applyBtn(
        "product-select-style__modal-shape-select-option-img-active",
        "ProductDetailImageURL_s"
      )
    }
    if(isColor){
      modalColorApplyBtn(
        "product-select-style__modal-color-custom-img-block-active",
        "skuId",
        "colorFinish",
        "imageItem"
      )
    }
  }
  const showActivePreviewImgShape = async (i) => {
    showActivePreview(
      "modal-shape-select-option-img" + i,
      "product-select-style__modal-shape-select-option-img",
      true,
      i
    )
    await timeout(2000);
    if(isShape){
      // applyBtn(
      //   "product-select-style__modal-shape-select-option-img-active",
      //   "ProductDetailImageURL_s"
      // )
      applySelectedShape(i)
    }
  }
  const isActiveskuId = "skuId"
  const isActiveSkuValue = activeSku

  const handleMouseEnter = (skuValue, imageValue) => {
    let imageTag = productImages.filter((image) => image.sku === skuValue);
    setHoverSkuImg(imageTag.length > 0  ? imageTag[0].tag: null)
    setHoveredSku(skuValue)
  }
  const handleMouseLeave = () => {
    setHoverSkuImg(null)
    setHoveredSku(null)
  }

  const uncheckFilterAll = () => {
    setSelectedColors([])
  }

  return (
    <div>
      {!isDiscontinued && !isColorDiscontinued && showModal && (
        <div className="product-select-style__overlay">
          <div className="product-select-style__modal">
            <div className="product-select-style__modal-row">
              <div
                className={
                  isShape
                    ? "select-style-popup product-select-style__modal-main-block shape-block"
                    : "select-style-popup product-select-style__modal-main-block"
                }
              >
                
                {isShape && (
                  <div className="select-style-view product-select-style__modal-color-image-block">
                    <div className="select-style-view-img product-select-style__modal-color-image-box">
                      {image.length > 0 &&
                        image.map((imageItem, i) => {
                          return (
                            imageItem["isActive"] === true && (
                              <img
                                onError={e =>
                                  (e.target.src = MissingImage?.src)
                                }
                                src={
                                  imageItem["src"]
                                    ? imageItem["src"]
                                    : MissingImage?.src
                                }
                                className="product-select-style__modal-color-image-preview"
                                id="product-select-style__modal-image-preview"
                              />
                            )
                          )
                        })}
                    </div>
                  </div>
                )}
                {isColor && (
                  <div className="select-style-view product-select-style__modal-color-image-block">
                    <div
                      className="select-style-view-img product-select-style__modal-color-image-box"
                      id="modal-color-image-box-block"
                    >
                      {colorsPopUp.length > 0 &&
                        colorsPopUp.map((colorsItem, i) => {
                          const colorsImage = colorsItem["src"] && colorsItem["src"]
                          const updatedImageWithPreset =
                            colorsImage &&
                            getAsPDPThumbnail(
                              swatchUrl,
                              presetConfig,
                              hoverSkuImg ? hoverSkuImg : activeSkuImg,
                              accountName
                            )
                          return (
                            
                            colorsItem["isActive"] === true && (
                              <img
                                {...{ [isActiveskuId]: isActiveSkuValue }}
                                onError={e =>
                                  (e.target.src = MissingImage?.src)
                                }
                                src={
                                  updatedImageWithPreset ?? MissingImage?.src
                                }
                                className="product-select-style__modal-color-image-preview"
                                id="product-select-style__modal-color-image-preview"
                              />
                            )
                          )
                        })}
                    </div>
                  </div>
                )}
                <div className="select-style-info product-select-style__modal-content-block">
                  <div className="product-select-style__modal-close">
                    <img
                      onError={e => (e.target.src = MissingImage?.src)}
                      src={closeIcon?.src}
                      alt="close"
                      onClick={() => closeModal()}
                    />
                  </div>
                  {isShape && (
                    <div className="product-select-style__modal-color-title-block shape-title-block">
                      <div className="product-select-style__modal-color-title">
                        {i18n.productSelectStyleShapeLabel}
                      </div>
                      <div className="product-select-style__modal-color-total-options">
                        <span className="product-select-style__modal-color-total-block">
                          {image !== undefined && image !== ""
                            ? image.length
                            : ""}
                        </span>
                        <span className="product-select-style__modal-shape-total-label">
                          {i18n.productSelectStyleShapeTotalOptions}
                        </span>
                      </div>
                    </div>
                  )}
                  {isColor && (
                    <div className="product-select-style__modal-color-title-block color-title-block">
                      <div className="product-select-style__modal-color-title">
                        {i18n.productSelectStyleModalColorTitle}
                      </div>
                      <div className="product-select-style__modal-color-total-options">
                        <div className="product-select-style__modal-color-total-block">
                          <span className="product-select-style__modal-color-total">
                            {colorFamilyFilteredValues.length > 0 ? 
                            `${colorFamilyFilteredValues?.length}/${ColorFinishLength}` : 
                            `${ColorFinishLength}`
                            }
                          </span>
                          <span className="product-select-style__modal-color-total-label">
                            {i18n.productSelectStyleShapeTotalOptions}
                          </span>
                        </div>

                        <div className="product-select-style__modal-color-filter-block"
                             onClick={() => openFilter()}  
                        >
                          <img
                            onError={e => (e.target.src = MissingImage?.src)}
                            src={filterAll?.src}
                            className="product-select-style__modal-color-filter-icon"
                          />
                          <span className="product-select-style__modal-color-filter-label-block">
                            <span
                              className="product-select-style__modal-color-filter-label"
                              id="product-select-style__filter-label"
                            >
                              {showFilter ? i18n.productSelectStyleShowFilter : i18n.productSelectStyleHideFilter}
                            </span>
                            {selectedColors?.length > 0 && 
                              <span className="product-select-style__modal-color-filter-count">
                                ({selectedColors.length + " " + i18n.productSelectStyleAppliedLabel})
                              </span>
                            }
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                  {isColor && !showFilter && (
                    <div
                      className="product-select-style__modal-color-checkbox-block"
                      id="prduct-select-style__color-panel"
                      style={{'display':'block'}}
                    >
                      {colorFinishMapping?.length > 0 &&
                        colorFinishMapping.map(colorItems => {
                          const [colorItem, colorCount] = colorItems.split("|")
                          return (
                            <div
                              key={colorItem}
                              className="product-select-style__modal-color-checkbox"
                            >
                              <label className="checkbox checkbox__black">
                                <input
                                  type="checkbox"
                                  className="finish_selection_checkbox"
                                  name=""
                                  value={colorItem}
                                  checked={selectedColors.includes(colorItem)}
                                  onChange={event =>
                                    handleCheckboxChange(event, colorItem)
                                  }
                                />
                                <div className="checkbox__marker">
                                  <img
                                    className="checkbox__marker-icon"
                                    src={checkIcon?.src}
                                    alt="Checkbox"
                                  />
                                </div>
                                <span className="checkbox__color-name">
                                  {colorItem}
                                  <span className="checkbox__color-count">
                                    ({colorCount})
                                  </span>
                                </span>
                              </label>
                            </div>
                          )
                        })}
                      <>
                        {selectedColors && selectedColors.length > 0 && (
                          <div className="product-select-style__modal-clearall-block">
                            <span
                              className="product-select-style__clearall-button"
                              onClick={() => uncheckFilterAll()}
                            >
                              {i18n.productSelectStyleModalClearAll}
                            </span>
                          </div>
                        )}
                      </>
                    </div>
                  )}

                  {isShape && (
                    <div className="product-select-style__modal-color-select-block">
                      <div className="product-select-style__modal-color-custom-select">
                        <ul className="product-select-style__modal-color-ul m-0">
                          {image.length > 0 &&
                            image.map((imageItem, i) => {
                              return (
                                <li
                                  key={i}
                                  className="product-select-style__modal-color-li"
                                  onClick={() => showActivePreviewImgShape(i)}
                                >
                                  <a
                                    href="javascript:void(0)"
                                    className="product-select-style__modal-shape-link"
                                    onMouseOver={() =>
                                      updateShapeImagePreview(imageItem["src"])
                                    }
                                  >
                                    <img
                                      onError={e =>
                                        (e.target.src = MissingImage?.src)
                                      }
                                      src={imageItem["src"]}
                                      className={
                                        imageItem["isActive"] === true
                                          ? "product-select-style__modal-shape-select-option-img product-select-style__modal-shape-select-option-img-active"
                                          : "product-select-style__modal-shape-select-option-img"
                                      }
                                      id={"modal-shape-select-option-img" + i}
                                    />
                                    <span className="product-select-style__modal-shape-sub-heading">
                                      {imageItem["name"]}
                                    </span>
                                  </a>
                                </li>
                              )
                            })}
                        </ul>
                      </div>
                    </div>
                  )}
                  {isColor && (
                    <div
                      className={`product-select-style__modal-color-select-block ${
                        showFilter ? "filter-open" : ""
                      }`}
                    >
                      <div
                        className="product-select-style__modal-color-custom-select"
                        id="modal-color-select-block"
                      >
                        <ul className="product-select-style__modal-color-ul m-0">
                          {selectedColors.length === 0
                            ? colorFamilyDetails.length > 0 &&
                              colorFamilyDetails.map((value, index) => {
                                const [
                                  colorValue,
                                  colorItemValue,
                                  imageValue,
                                  skuValue,
                                ] = value.split("|")
                                const finishName = colorsPopUp.find(
                                  cp => cp?.skuId === skuValue
                                )?.finishName
                                const dynamicskuId = "skuId"
                                const dynamicSkuValue = skuValue
                                const dynamicColorFinish = "colorFinish"
                                const imageSrc = "imageItem"
                                const dynamicColorFinishValue = `${colorItemValue} ${
                                  index <= colorsPopUp.length - 1
                                    ? `- ${colorsPopUp[index]["finishName"]}`
                                    : ""
                                }`
                                const colorsImage = imageValue && imageValue
                                const urlParts =
                                  colorsImage && colorsImage?.split("/")
                                const imageId =
                                  urlParts && urlParts[urlParts?.length - 1]
                                const updatedImageWithPreset =
                                  colorsImage &&
                                  getAsPDPThumbnail(
                                    swatchUrl,
                                    presetConfig,
                                    imageId,
                                    accountName
                                  )
                                return (
                                  <li
                                    key={index}
                                    onClick={() =>
                                      showActivePreviewImg(skuValue, imageValue)
                                    }
                                    onMouseEnter={() =>
                                      handleMouseEnter(skuValue, imageValue)
                                    }
                                    onMouseLeave={handleMouseLeave}
                                    className="product-select-style__modal-color-li"
                                  >
                                    <span className="product-select-style__modal-color-link">
                                      <span
                                        className={
                                          activeSku === skuValue
                                            ? "product-select-style__modal-color-custom-img-block product-select-style__modal-color-custom-img-block-active"
                                            : "product-select-style__modal-color-custom-img-block"
                                        }
                                        {...{
                                          [dynamicskuId]: dynamicSkuValue,
                                          [dynamicColorFinish]:
                                            dynamicColorFinishValue,
                                          [imageSrc]: imageValue,
                                        }}
                                      >
                                      { colorsImage !== "N/A" ? (
                                          <img
                                            className="product-select-style__modal-color-select-option-img"
                                            src={updatedImageWithPreset}
                                            alt={colorValue}
                                            onError={e =>
                                              (e.target.src = MissingImage?.src)
                                            }
                                          />
                                        ) : (
                                          <img
                                            className="product-select-style__modal-color-select-option-no-img"
                                            src={MissingImage?.src}
                                            alt={colorValue}
                                          />
                                        )}
                                      </span>
                                      <span className="product-select-style__modal-color-sub-heading">
                                        {colorItemValue}{" "}
                                        {index <= colorsPopUp.length - 1
                                          ? ` - ${finishName}`
                                          : ""}
                                      </span>
                                    </span>
                                  </li>
                                )
                              })
                            : colorFamilyFilteredValues.map((value, index) => {
                                const [
                                  colorValue,
                                  colorItemValue,
                                  imageValue,
                                  skuValue,
                                ] = value.split("|")
                                const filteredPopup = colorsPopUp.find(
                                  cp => cp["skuId"] === skuValue
                                )
                                const dynamicskuId = "skuId"
                                const dynamicSkuValue = skuValue
                                const dynamicColorFinish = "colorFinish"
                                const imageSrc = "imageItem"
                                const dynamicColorFinishValue = `${colorItemValue} - ${filteredPopup["finishName"]}`

                                const colorsImage = imageValue && imageValue
                                const urlParts =
                                  colorsImage && colorsImage?.split("/")
                                const imageId =
                                  urlParts && urlParts[urlParts?.length - 1]
                                const updatedImageWithPreset =
                                  colorsImage &&
                                  getAsPDPThumbnail(
                                    swatchUrl,
                                    presetConfig,
                                    imageId,
                                    accountName
                                  )
                                return (
                                  <li
                                    key={index}
                                    onClick={() =>
                                      showActivePreviewImg(skuValue, imageValue)
                                    }
                                    onMouseEnter={() =>
                                      handleMouseEnter(skuValue, imageValue)
                                    }
                                    onMouseLeave={handleMouseLeave}
                                    className="product-select-style__modal-color-li"
                                  >
                                    <span className="product-select-style__modal-color-link">
                                      <span
                                        className={
                                          activeSku === skuValue
                                            ? "product-select-style__modal-color-custom-img-block product-select-style__modal-color-custom-img-block-active"
                                            : "product-select-style__modal-color-custom-img-block"

                                        }
                                        {...{
                                          [dynamicskuId]: dynamicSkuValue,
                                          [dynamicColorFinish]:
                                            dynamicColorFinishValue,
                                          [imageSrc]: imageValue,
                                        }}
                                      >
                                      { colorsImage !== "N/A" ? (
                                          <img
                                            className="product-select-style__modal-color-select-option-img"
                                            src={updatedImageWithPreset}
                                            alt={colorValue}
                                            onError={e =>
                                              (e.target.src = MissingImage?.src)
                                            }
                                          />
                                        ) : (
                                          <img
                                            className="product-select-style__modal-color-select-option-no-img"
                                            src={MissingImage?.src}
                                            alt={colorValue}
                                          />

                                        )}
                                      </span>
                                      <span className="product-select-style__modal-color-sub-heading">
                                        {colorItemValue} -{" "}
                                        {filteredPopup["finishName"]}
                                      </span>
                                    </span>
                                  </li>
                                )
                              })}
                            <div className="product-select-style__title">
                              { styleOptionsNotPresent 
                              && (<span
                                    className="product-select-style__note"
                                    dangerouslySetInnerHTML={{
                                      __html: DOMPurify.sanitize(
                                        cleanRedirectLinks(selectYourStyleInfo)
                                      ),
                                    }}
                                />)}
                            </div>
                        </ul>
                      </div>
                    </div>
                  )}
                  
                  {/* {isColor && (
                    <div className="product-select-style__modal-color-footer-block">
                      <div className="product-select-style__modal-color-button-block">
                        <button
                          className="product-select-style__modal-color-apply-btn"
                          type="button"
                          onClick={() =>
                            modalColorApplyBtn(
                              "product-select-style__modal-color-custom-img-block-active",
                              "skuId",
                              "colorFinish",
                              "imageItem"
                            )
                          }
                        >
                          {i18n.productSelectStyleShapeApplyBtn}
                        </button>
                      </div>
                    </div>
                  )}
                  {isShape && (
                    <div className="product-select-style__modal-color-footer-block">
                      <div className="product-select-style__modal-shape-button-block">
                        <button
                          className="product-select-style__modal-shape-apply-btn"
                          type="button"
                          onClick={() =>
                            applyBtn(
                              "product-select-style__modal-shape-select-option-img-active",
                              "ProductDetailImageURL_s"
                            )
                          }
                        >
                          {i18n.productSelectStyleShapeApplyBtn}
                        </button>
                      </div>
                    </div>
                  )} */}
                  {/* 
                      The Above two lines are commented for the ticket AS-9510
                      AS | PDP | Select Your Style | Modal Popup experience to be improved
                  */}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default ProductColorFinish
